<template>
    <span>
        <div class="flex flex-col w-full h-52 items-center justify-center splash-screen-loading-box" v-if="loading">
            <n-spin :size="80" />
        </div>
        
        <div v-else class="page">
            <n-form
                ref="formRef"
                :model="storeEvents.activityConfiguration"
                :rules="rules"
                :size="size"
                label-placement="top"
            >
                <n-grid :x-gap="24">
                    <n-form-item-gi :span="12" :label="$t('gm.dashboards.sets')" path="challenges">
                        <n-transfer
                            v-model:value="storeEvents.activityConfiguration.bingos_set"
                            style="width: 100%"
                            :options="bingo_set_options"
                        />
                    </n-form-item-gi>
                    <!-- Type Online, Physical with radio button -->
                    <n-form-item-gi :span="12" :label="t('gm.dashboards.type_game')" path="type">
                        <n-radio-group v-model:value="storeEvents.activityConfiguration.type" :options="type_options" >
                            <n-radio v-for="option in type_options" :key="option.value" :value="option.value" :label="option.label" :default="option.default" />
                        </n-radio-group>
                    </n-form-item-gi>
                </n-grid>
            </n-form>
        </div>
    </span>
</template>

<script lang="ts" setup>
import Icon from "@/components/common/Icon.vue"
import { NButton, NForm, NFormItemGi, NInputNumber, NTransfer, useMessage, NSpin, NGrid, type FormItemRule, NRadioGroup, NRadio} from "naive-ui"
import { computed, onMounted, ref, Ref, watch } from "vue"
import { type LabelPlacement, type Size, FormInst } from "naive-ui/es/form/src/interface"
import { useRoute, useRouter } from "vue-router"
import { useEventsStore } from "@/stores/apps/events"
import { axiosToken, fetchPromiseAll } from "@/utils/http";
import type { AxiosResponse } from "axios";
import { useUTQStore } from "@/stores/apps/utq"
import { useContentStore } from "@/stores/apps/content"
import { useStoreI18n } from "@/composables/useStoreI18n"
import { getTranslatedObject } from "@/utils/translate"
import { useMusicalBingoStore } from "@/stores/apps/musical_bingo"

const { t } = useStoreI18n();

const storeEvents = useEventsStore()
const storeContent = useContentStore()
const storeMusicalBingo = useMusicalBingoStore()
const route = useRoute()
const size = ref<Size | undefined>("medium")
const bingo_set_options = ref([]) 
const loading = ref(true)
const formRef = ref<FormInst | null>(null)
const type_options = ref([
    {
        label: t('gm.dashboards.presential'),
        value: 'PRESENTIAL',
        default: true
    },
    {
        label: t('gm.dashboards.online'),
        value: 'ONLINE'
    }
])
onMounted( async () => {
    
    storeEvents.activityConfiguration = {bingos_set: [], activity_formRef: formRef}
    if(route.params.api_key)
    {
        await fetchPromiseAll ([
            storeEvents.getEventFull(String(route.params.api_key)),
            storeContent.getAllContent("musical_bingo_set"),
            storeMusicalBingo.getMusicalBingoData(String(route.params.api_key)),
        ])
        storeEvents.activityConfiguration.bingos_set = storeMusicalBingo.musicalBingoData.bingos_set.map(v => v.id)
        storeEvents.activityConfiguration.type = storeMusicalBingo.musicalBingoData.type
    }
    else
    {
        await fetchPromiseAll ([
            storeContent.getAllContent("musical_bingo_set"),
        ])
    }
    
    bingo_set_options.value = storeContent.content.musical_bingo_set.map(v => ({
        label:v.songs.length  < 25 || v.challenges.length == 0 ? v.name + "( Less than 25 songs or 0 challenges)" : v.name , 
        value: v.id, 
        disabled: v.songs.length < 25 || v.challenges.length == 0}))
    
    loading.value = false
});

const rules = {
        bingos_set: {
                type: 'array',
                required: true,
                trigger: 'change',
                message: t('gm.dashboards.select_challenge')
            },
        };

</script>

<style lang="scss" scoped>

.components-list {
	grid-template-columns: none;
}
.card-css {
    background-color: var(--bg-color);
}
</style>
